/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
      {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "auditTrialReport.tableColumns.user",
        accessor: "action_done_by",
      },
      {
        Header: "auditTrialReport.tableColumns.dateAndTime",
        accessor: "created_at",
      },
      {
        Header: "auditTrialReport.tableColumns.action",
        accessor: "action",
      },
      {
        Header: "auditTrialReport.tableColumns.ipAddress",
        accessor: "ip_address",
      },
      {
        Header: "auditTrialReport.tableColumns.remarks",
        accessor: "title",
      },
      
]


interface TableColumn {
    Header: string;
    accessor: string;
  }